<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
    <slot />
    <g fill="none" fill-rule="evenodd" transform="translate(0 .5)">
      <rect width="13" height="10" x=".5" y="7" :stroke="color" rx="1" />
      <rect width="2" height="5" x="6" y="9.5" :fill="color" rx="1" />
      <path :stroke="color" d="M10.5 7.5v-4C10.5 1.429 9.21 0 7 0S3.5 1.429 3.5 3.5v4" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
